export var darkTheme = {
    // Colors
    background: '#0f172a',
    text: '#f1f5f9',
    textSecondary: '#cbd5e1',
    textMuted: '#64748b',
    border: '#334155',
    borderLight: '#1e293b',
    paper: '#1e293b',
    paperLight: '#334155',
    paperHover: '#334155',
    paperActive: '#475569',
    paperDark: '#0f172a',
    primary: '#3b82f6',
    primaryDark: '#2563eb',
    primaryLight: '#60a5fa',
    primaryText: '#ffffff',
    secondary: '#8b5cf6',
    secondaryDark: '#7c3aed',
    secondaryLight: '#a78bfa',
    secondaryText: '#ffffff',
    shadow: 'rgba(0, 0, 0, 0.3)',
    // Alert colors
    info: '#60a5fa',
    infoLight: '#1e293b',
    success: '#34d399',
    successLight: '#064e3b',
    warning: '#fbbf24',
    warningLight: '#451a03',
    error: '#f87171',
    errorLight: '#450a0a',
    // Typography
    typography: {
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: {
            xs: '12px',
            sm: '14px',
            base: '16px',
            lg: '18px',
            xl: '20px',
            xxl: '24px'
        },
        fontWeight: {
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700
        }
    },
    // Spacing
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px'
    },
    // Border radius
    radius: {
        sm: '0.25rem',
        md: '0.375rem',
        lg: '0.5rem',
        xl: '0.75rem',
        full: '9999px'
    },
    // Transitions
    transition: {
        fast: '150ms ease-in-out',
        normal: '300ms ease-in-out',
        slow: '450ms ease-in-out'
    },
    // Breakpoints
    breakpoints: {
        xs: '480px',
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px'
    },
    // Theme state
    isDark: true,
    // Additional colors for specific components
    tooltipBg: '#f1f5f9',
    tooltipText: '#0f172a'
};
